import React, { useState } from 'react';
import { FadeIn } from './ui';
import { Check } from 'lucide-react';
type OptionId = 'primaria' | 'pack-completo' | 'secundaria';
interface CheckoutOption {
  id: OptionId;
  title: string;
  icon: string;
  subtitle: string;
  oldPrice: string;
  newPrice: string;
  badges?: {
    text: string;
    type: 'primary' | 'secondary';
  }[];
  ctaText: string;
  ctaSubtext: string;
  url: string;
  features: string[];
  highlight?: boolean;
}
const options: CheckoutOption[] = [{
  id: 'primaria',
  title: 'PACK PRIMARIA',
  icon: '📘',
  subtitle: '6 tomos + 120 clases + bonos',
  oldPrice: '$49.900',
  newPrice: '$16.990',
  ctaText: 'SÍ, QUIERO PACK PRIMARIA →',
  ctaSubtext: 'Ideal para docentes de nivel primario',
  url: 'https://profelisto.com.ar/checkouts/cn/hWNBs8K9c7AzoewthRczx12A/es-ar?_r=AQABdPNvQrs3Am10nFmxBIlI6YChgzR61-ocUFlcMAwIXD0',
  features: ['6 Tomos de Primaria', '+120 clases con secuencia', 'Rúbricas incluidas', 'Bonos estratégicos', 'Acceso inmediato PDF']
}, {
  id: 'pack-completo',
  title: 'PACK COMPLETO',
  icon: '🏆',
  subtitle: '12 tomos + 240 clases + bonos + 3 Ebooks Élite',
  oldPrice: '$99.980',
  newPrice: '$27.990',
  badges: [{
    text: '⭐ MÁS ELEGIDO',
    type: 'primary'
  }, {
    text: 'AHORRÁS $7.990',
    type: 'secondary'
  }],
  ctaText: 'SÍ, QUIERO PACK COMPLETO →',
  ctaSubtext: 'La opción más elegida por docentes que enseñan en los dos niveles',
  url: 'https://profelisto.com.ar/checkouts/cn/hWNBs8O01rTVIPWQjgykvV3q/es-ar?_r=AQAB77FQ4FUxz-mTgc3HD_cD7-7700rg_Uip5eru-3NTBqo',
  features: ['12 Tomos completos', '+240 clases con secuencia', 'Primaria + Secundaria', 'Rúbricas incluidas', '6 Bonos estratégicos', 'Acceso inmediato PDF', 'Ebook Elite: Resolución de Conflictos', 'Ebook Elite: Marca Personal', 'Ebook Elite: Organización Docente'],
  highlight: true
}, {
  id: 'secundaria',
  title: 'PACK SECUNDARIA',
  icon: '📗',
  subtitle: '6 tomos + 120 clases + bonos',
  oldPrice: '$49.990',
  newPrice: '$18.990',
  ctaText: 'SÍ, QUIERO PACK SECUNDARIA →',
  ctaSubtext: 'Ideal para docentes de nivel secundario',
  url: 'https://profelisto.com.ar/checkouts/cn/hWNBs8Ptw36sV82UDlswnBHW/es-ar?_r=AQABS7FXdvkks2MJiIVKBLHkPST4GugqaZpi_CsUOaHIa5Y',
  features: ['6 Tomos de Secundaria', '+120 clases con secuencia', 'Rúbricas incluidas', 'Bonos estratégicos', 'Acceso inmediato PDF']
}];
export function CheckoutSection() {
  const [selectedId, setSelectedId] = useState<OptionId>('pack-completo');
  const selectedOption = options.find(o => o.id === selectedId)!;
  return <section id="pricing" className="py-10 md:py-[100px] px-4 bg-white" data-id="element-50">
      <div className="max-w-[680px] mx-auto w-full" data-id="element-51">
        <FadeIn data-id="element-52">
          <div className="space-y-3 md:space-y-4 mb-5 md:mb-6" data-id="element-53">
            {options.map(option => {
            const isSelected = selectedId === option.id;
            const isHighlight = option.highlight;
            return <div key={option.id} onClick={() => setSelectedId(option.id)} className={`relative cursor-pointer rounded-2xl transition-all duration-300 border-2 ${isSelected ? 'bg-brand-green/5 border-brand-green shadow-[0_0_25px_rgba(5,150,105,0.18)]' : 'bg-gray-50 border-gray-200 hover:border-gray-300'} ${isHighlight ? 'p-5 md:p-7' : 'p-4 md:p-6'}`} data-id="element-54">
                  <div className="flex items-center gap-3 md:gap-4" data-id="element-55">
                    {/* Radio */}
                    <div className="shrink-0" data-id="element-56">
                      <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-brand-green' : 'border-gray-400'}`} data-id="element-57">
                        {isSelected && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-green" data-id="element-58" />}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 flex items-center justify-between gap-2 md:gap-4 min-w-0" data-id="element-59">
                      <div className="min-w-0" data-id="element-60">
                        <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-61">
                          <span className={isHighlight ? 'text-xl md:text-2xl' : 'text-lg md:text-xl'} data-id="element-62">
                            {option.icon}
                          </span>
                          <h3 className={`font-black text-gray-900 ${isHighlight ? 'text-lg md:text-2xl' : 'text-base md:text-xl'}`} data-id="element-63">
                            {option.title}
                          </h3>
                        </div>
                        {option.badges && <div className="flex flex-wrap gap-1.5 md:gap-2 mb-1" data-id="element-64">
                            {option.badges.map((badge, i) => <span key={i} className={`text-[9px] md:text-xs font-bold px-2 py-0.5 rounded-full ${badge.type === 'primary' ? 'bg-brand-gold text-white' : 'bg-brand-green/10 text-brand-green'}`} data-id="element-65">
                                {badge.text}
                              </span>)}
                          </div>}
                        <p className="text-gray-500 text-xs md:text-sm" data-id="element-66">
                          {option.subtitle}
                        </p>
                      </div>

                      <div className="text-right shrink-0" data-id="element-67">
                        <div className="text-gray-400 text-xs md:text-sm line-through decoration-gray-400" data-id="element-68">
                          {option.oldPrice}
                        </div>
                        <div className={`font-black ${isSelected ? 'text-brand-green' : 'text-gray-900'} ${isHighlight ? 'text-2xl md:text-4xl' : 'text-xl md:text-3xl'}`} data-id="element-69">
                          {option.newPrice}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>;
          })}
          </div>

          <a href={selectedOption.url} className="block w-full bg-brand-green hover:bg-brand-greenHover text-white text-center font-black rounded-xl py-3.5 md:py-5 px-6 text-base md:text-xl transition-all duration-300 shadow-[0_0_20px_rgba(5,150,105,0.25)] hover:shadow-[0_0_30px_rgba(5,150,105,0.4)] md:hover:-translate-y-1 active:scale-[0.98] mb-2 md:mb-3" data-id="element-70">
            {selectedOption.ctaText}
          </a>

          <p className="text-gray-500 text-center text-xs md:text-sm italic mb-5 md:mb-8" data-id="element-71">
            {selectedOption.ctaSubtext}
          </p>

          {/* Features box - hidden on mobile to save space */}
          <div className="hidden md:block bg-gray-50 border border-gray-200 rounded-2xl p-5 md:p-8 mb-8" data-id="element-72">
            <h4 className="text-gray-500 text-xs md:text-sm font-bold tracking-widest uppercase mb-4 md:mb-6" data-id="element-73">
              {selectedOption.title} INCLUYE:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 md:gap-y-4 gap-x-6" data-id="element-74">
              {selectedOption.features.map((feature, i) => <div key={i} className="flex items-start gap-2" data-id="element-75">
                  <Check size={18} className="text-brand-green shrink-0 mt-0.5" data-id="element-76" />
                  <span className="text-gray-700 text-sm md:text-base" data-id="element-77">
                    {feature}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Trust row */}
          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 md:gap-x-6 text-[12px] md:text-sm text-gray-600 font-medium" data-id="element-78">
            <div className="flex items-center gap-1.5" data-id="element-79">
              <span data-id="element-80">🔒</span> Pago seguro
            </div>
            <span className="text-gray-300 hidden md:inline" data-id="element-81">·</span>
            <div className="flex items-center gap-1.5" data-id="element-82">
              <span data-id="element-83">📥</span> Descarga inmediata
            </div>
            <span className="text-gray-300 hidden md:inline" data-id="element-84">·</span>
            <div className="flex items-center gap-1.5" data-id="element-85">
              <span data-id="element-86">🛡️</span> Garantía de 7 días
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}